// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your Firebase credentials
const firebaseConfig = {
  apiKey: "AIzaSyBqORAckUgiwnkX1yTIAeK5mBP5M4wUHx0",
  authDomain: "chatapp2143.firebaseapp.com",
  projectId: "chatapp2143",
  storageBucket: "chatapp2143.firebasestorage.app",
  messagingSenderId: "89178422738",
  appId: "1:89178422738:web:72ff6f6651c826d5095c0b",
  measurementId: "G-V38272KCHG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
